module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_24-f5ca161eaa2c7a64d994b2711fc2e37a.jpg";